import React from 'react';
import {
  AnvilForm,
} from 'components/anvilFormFillable/fields/types';
import {
  getFieldDisplayLabel,
  isFormFieldRequired,
} from 'components/anvilFormFillable/utils';

type Props = {
  field: AnvilForm;
  id: string;
};

export default function FormFieldWizardLabel({
  field,
  id,
}: Props) {
  const text = getFieldDisplayLabel(field);
  const required = isFormFieldRequired(field);

  if (!text) {
    return null;
  }

  return (
    <label htmlFor={id} className="font-semibold">
      {text}
      {!required && (
        <span className="text-[11px] italic font-normal text-gray-400 ml-1">(Optional)</span>
      )}
    </label>
  );
}
